import * as React from 'react';
import styles from './index.module.scss';
import cx from 'classnames';
import Loader from '../../components/Loader';
import BookmarkItem from './story-item';
import { Button } from '@fluentui/react-northstar';
import Carousel from 'react-multi-carousel';
import "react-multi-carousel/lib/styles.css";
import CarouselRightArrow from '../../components/Carousel/right';
import CarouselLefttArrow from '../../components/Carousel/left';
import { useDispatch } from 'react-redux';
import { useTypedSelector } from '../../store';
import { ApplicationState } from '../../store/appThunkAction';
import { selectRecommandationStory } from '../../store/Meeting/actions';
import { getFile, getStory } from '../../store/Story/actions';
import envConfig from '../../config';
import { Bookmark, File } from '../../store/Story/modal';
import { HubFile } from '../../model';
import BookmarkFileItems from './file-item';

const BookmarkContainer = () => {

    const dispatch = useDispatch();
    const [node, setNode] = React.useState({} as any);
    const [width, setWidth] = React.useState(0);


    const {
        selectedBookmarkId,
    } = useTypedSelector((state: ApplicationState) => state.meeting);

    const {
        stories: cacheStories,
        files: cacheFiles,
    } = useTypedSelector((state: ApplicationState) => state.story);

    const {
        bookmarks: items,
        loading
    } = useTypedSelector((state: ApplicationState) => state.bookmark);

    const updateSelectedStory = (id: number) => {
        dispatch(selectRecommandationStory(id))
    }
    const rootClass = cx(styles.root, selectedBookmarkId > 0 && styles.all);
    const selectedStory = items.find(c => c.id == selectedBookmarkId);


    const responsive = {
        superLargeDesktop: {
            breakpoint: { max: 4000, min: 10 },
            items: width / (192 + 26)
        },
    };
    React.useEffect(() => {
        function handleResize() {
            setWidth(node.offsetWidth)
        }
        window.addEventListener('resize', handleResize)
    }, [node]);
    React.useEffect(() => {
        setWidth(width);
    }, [items]);

    React.useEffect(() => {
        items.forEach((bookmarkItem) => {
            if (bookmarkItem) {
                bookmarkItem.setData.forEach((currentItem) => {
                    if (currentItem.type === 'story') {
                        if (!cacheStories[currentItem.permId]) {
                            dispatch(getStory(currentItem.permId));
                        }
                    } else {
                        if(!cacheFiles[currentItem.id]) {
                            dispatch(getFile(currentItem.id));
                        }

                    }
                })
            }
        })

    }, [items]);
    const filterBookmarks: Bookmark[] = (items || []).map((item) => {
        if (item.setData.length > 0) {
            const allFiles = item.setData.filter(c => c.type === 'file').length === item.setData.length;
            if (allFiles) {
                const files = item.setData.filter((c: any) => envConfig.invalidCategory.indexOf(c.category) < 0) as unknown as File[];
                if (files.length > 0) {
                    const mapFiles = files.map(file => cacheFiles[file.id]).filter(c => !!c);
                    if (mapFiles.length > 0) {
                        return {
                            id: item.id,
                            name: item.name,
                            storyId: mapFiles[0].permId,
                            thumbnail: mapFiles[0].thumbnail,
                            files: mapFiles
                        }
                    }
                }
                return null;
            } else if(item.setData[0].type === 'story') {
                const storyDetails = cacheStories[item.setData[0].permId];
                if(storyDetails) {
                
                    const files = storyDetails.files.filter((c: any) => envConfig.invalidCategory.indexOf(c.category) < 0) as unknown as File[];
                    if (files.length > 0) {
                        return {
                            id: item.id,
                            name: item.name,
                            storyId: storyDetails.perm_id,
                            thumbnail: files[0].cover_art_url,
                            files: files.map(file => {
                                return {
                                    id: file.id,
                                    category: file.category,
                                    thumbnail: file.cover_art_url,
                                    createdAt: file.created_at,
                                    description: file.description,
                                    excerpt: file.description,
                                    filePermId: file.id,
                                    permId:  storyDetails.perm_id
                                } as unknown as HubFile;
                            })
                        }
                    }
                }
            }
               
        }
        return null;
    }).filter(c=>c !== null) as unknown as Bookmark[];
    const selectedBookmark = filterBookmarks.find(c=>c.id === selectedBookmarkId);
    return (
        <div className={rootClass}>
            {selectedBookmarkId === 0 && <div ref={node => {
                node && setNode(node);
                node && setWidth(node.offsetWidth);
            }} className={styles.header}>
                <h1>Bookmarks</h1>
            </div>}
            {selectedBookmarkId === 0 && loading && <div className={styles.loader}><Loader /></div>}
            {selectedBookmarkId === 0 && <div className={styles.container}>
                <Carousel slidesToSlide={5} responsive={responsive} customLeftArrow={<CarouselLefttArrow />} customRightArrow={<CarouselRightArrow />} >
                    {filterBookmarks.map((item) => {
                        return <BookmarkItem key={item.id} {...item} />
                    })}
                </Carousel>
            </div>}
            {selectedBookmarkId > 0 && <div className={styles.header}>
                <Button onClick={() => updateSelectedStory(0)} text content={`Recommended > ${selectedStory ? selectedStory.name : ''}`} />
            </div>}
            {selectedBookmarkId > 0 && selectedBookmark && <BookmarkFileItems {...selectedBookmark} />}
        </div>
    )
};

export default BookmarkContainer
